export default __webpack_public_path__ + "static/media/LICENSING_DISTRIBUTION.57ff68f9.jpg";